/**
 * Session persistence helper for Transfer List filters.
 * Parity with Angular `propertytransferlist_filter` session key in `transfer-process-list.component.ts`.
 */

import type { TransferFilterFormValues } from '../types/transferFilterForm'
import type { TransferListParams } from '../types/transfer'

export const PROPERTY_TRANSFER_LIST_SESSION_KEY = 'propertytransferlist_filter'

export interface SavedTransferSessionFilter {
  search?: string
  org_id?: string
  company_id?: string
  property_id?: string
  process_name?: string
  fk_team_id?: string
  status?: string
  fromDt?: string
  toDt?: string
  dateStartISO?: string
  dateEndISO?: string
  page?: number
  perPage?: number
  sortBy?: 'asc' | 'desc'
  orderBy?: string
}

export function readTransferListSessionFilter(): SavedTransferSessionFilter | null {
  try {
    const raw = sessionStorage.getItem(PROPERTY_TRANSFER_LIST_SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object') {
      return parsed as SavedTransferSessionFilter
    }
    return null
  } catch {
    return null
  }
}

export function writeTransferListSessionFilter(
  form: TransferFilterFormValues,
  params: TransferListParams,
): void {
  try {
    const payload: SavedTransferSessionFilter = {
      search: form.search ?? '',
      org_id: form.org_id ?? '',
      company_id: form.company_id ?? '',
      property_id: form.property_id ?? '',
      process_name: form.process_name ?? '',
      fk_team_id: form.fk_team_id ?? '',
      status: form.status ?? 'Pending',
      page: params.page ?? 1,
      perPage: params.perPage ?? 15,
      sortBy: params.sortBy ?? 'desc',
      orderBy: params.orderBy ?? 'updated_at',
    }

    if (params.fromDt) payload.fromDt = params.fromDt
    if (params.toDt) payload.toDt = params.toDt
    if (form.dateStart) payload.dateStartISO = form.dateStart.toISOString()
    if (form.dateEnd) payload.dateEndISO = form.dateEnd.toISOString()

    sessionStorage.setItem(PROPERTY_TRANSFER_LIST_SESSION_KEY, JSON.stringify(payload))
  } catch {
    /* Best effort session storage */
  }
}

export function clearTransferListSessionFilter(): void {
  try {
    sessionStorage.removeItem(PROPERTY_TRANSFER_LIST_SESSION_KEY)
  } catch {
    /* Best effort session storage */
  }
}
